ready().then(function () {

    /**
     * Card book has a design problem, since all images having different img heights. We need to calculate the highest img and apply to the others - the rest of the cards height is done by css grid
     */
    window.applyHighestImgSize = () => {
        const imgbooklists = $('.calc-img-height');

        function loopThroughBookLists() {
            imgbooklists.each((id, booklist) => {
                const imageElements = $(booklist).find('.img-container img');
                const bookshelfContainers = $(booklist).find('.bookshelf');
                const imageContainers = $(booklist).find('.card-book .img-container');
                const imageHeights = [];

                imageElements.each((i, image) => {
                    image = $(image);
                    // The scaled image will be same size as the container
                    const scaledWidth = imageContainers.width();

                    const originalWidth = image.data('width');
                    const originalHeight = image.data('height');

                    // Fail gracefully
                    if (!originalWidth || !originalHeight) {
                        return;
                    }
                    /*
                     *   originalHeight               scaledHeight
                     * ------------------     =     ----------------     ( = an aspectRatio)
                     *   originalWidth                scaledWidth
                     *
                     * Thus:
                     *
                     *   originalHeight
                     * ------------------   *   scaledWidth   =   scaledHeight
                     *   originalWidth
                     */
                    const scaledHeight = originalHeight / originalWidth * scaledWidth;
                    imageHeights.push(scaledHeight);
                });

                if (imageElements.length === imageHeights.length) {
                    scaleImageCards(imageHeights, imageContainers, bookshelfContainers);
                }
            });
        }

        $(document).ready(function () {
            loopThroughBookLists();
        });

        $(document).on('resize ajaxComplete', function () {
            //Loop over list elements
            loopThroughBookLists();
        });
        $('.tab-selection').on('click', function () {
            // Loop through list elements in tab-selection
            loopThroughBookLists();
        });
    };

    let scaleImageCards = (heights, imgContainer, bookshelfContainers) => {
        let maxHeight = Math.max.apply(Math, heights);

        if (maxHeight > 0) {
            imgContainer.css('height', maxHeight);

            // Scale all bookshelves
            $(bookshelfContainers).css('top', maxHeight - 10);
            $('.bookshelf-search-middle').css('background-position-y', maxHeight - 10);
            $('.bookshelf-search-left').css('top', maxHeight - 10);
            $('.bookshelf-search-right').css('top', maxHeight - 10);
        }
    }
    applyHighestImgSize();
});
